export enum OpsScheduleStatus {
    Included = 1,
    Deleted = 2
}